<template>
  <div class="kydt">
    <div class="title1" v-show="showList">路演</div>
  </div>
</template>
<script>

export default {
  components: {
    
  },
  data() {
    return {
      
    }
  },
  created() {
    this.$router.push({path:'homeIndex'})
  },
  methods: {
    
  },
  mounted() {
   
  },
  beforeDestroy() {
     
    },
  watch: { // 监听，当路由发生变化的时候执行
     
  }
};
</script>

<style lang="less" scoped>
.title1 {
  text-align: center;
  font-size: 22px;
  margin: 10px 0 30px;
}
</style>